import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import get from "lodash/get";

import Layout from "../components/layout";
import ComponentLayout from "Components/common/base/componentLayout";

const HomePage = ({ location }) => {
  const { modals } = useStaticQuery(graphql`
    query {
      modals: strapi {
        homePage {
          page {
            isTopbarWhite
            isShopPage
            modals {
              ...blurbHeaderModal
              ...narrativeModal
              ...imageHeroModal
              ...longPressModal
              ...blurbModal
              ...logoHeaderModal
              ...textHeaderModal
              ...shortPressModal
              ...carouselProductModal
              ...customFitModal
              ...gridProductModal
              ...imageListModal
              ...socialModal
              ...imageBlurbModal
              ...photoCarousel
              ...caseStudyListModal
              ...faqModal
              ...dividerModal
            }
          }
        }
      }
    }
  `);

  return (
    <Layout
      title="Made for you. Made to fit. Made for every face."
      location={location}
      topbarColor={modals.homePage.page.isTopbarWhite ? "white" : "black"}
      isShopPage={modals.homePage.page.isShopPage}
    >
      <ComponentLayout modals={modals.homePage.page.modals} />
    </Layout>
  );
};

export default HomePage;
